export default __webpack_public_path__ + "static/media/133283__leszek-szary__game-over.529b17a9.mp3";